const columns = [
    {
        field: "name",
        label: "Nazwa",
        sort: "asc",
        width: 150,
    },


    {
        field: "dayRate",
        label: "Domek/Doba",
        width: 90,
    },
    {
        field: "adultRate",
        label: "Dorosły/Doba",
        width: 90,
    },
    {
        field: "childRate",
        label: "Dziecko 7-12/Doba",
        width: 90,
    },
    {
        field: "babyRate",
        label: "Dziecko 0-6/Doba",
        width: 90,
    },
    {
        field: "longerStayDiscounts",
        label: "Rabaty",
        width: 150,
        type: "length"
    },
];

export default columns;
